export const TRANSLATION_KEY = {
  OTHER: "Other",

  // STAFF STATUS
  TEMPORARY_STAFF: "Temporary Staff",
  WORKING_STAFF: "Working Staff",
  POOL_STAFF: "Pool Staff",

  // COMMUTING_METHOD_OPTIONS
  CAR: "car",
  BICYCLE: "bicycle",
  MOPED: "moped",
  MOTORCYCLE: "motorcycle",
  WALKING: "walking",
  PUBLIC_TRANSPORTATION: "public transportation",

  // PREFERRED_WORKING_SCHEDULE_OPTIONS
  DAY_SHIFT: "Day Shift",
  NIGHT_SHIFT: "Night Shift",
  ROTATIONAL_SHIFT_INCLUDING_MIDNIGHT: "Rotational Shift (including midnight)",
  ROTATIONAL_SHIFT_EXCLUDING_MIDNIGHT: "Rotational Shift (excluding midnight)",

  // TIME UNIT
  HOUR: "Hour",
  WEEK: "Week",
  MONTH: "Month",

  // PREFERRED_EMPLOYMENT_DURATION_VALUE
  LONG_TERM: "long_term",
  SHORT_TERM: "short_term",

  //ARCHIVE REASON TITLE OPTIONS
  CANCELED: "TASK_CANCELED",
  DUPLICATE: "DUPLICATE",
  COMPLETED: "TASK_COMPLETED",
  MISCOMMUNICATION: "MISSCOM",
  OUTDATED: "OUTDATED",

  //INTERVIEW TYPE
  POOL_STAFF_INTERVIEW: "Pool Staff Interview",
  WORKING_STAFF_INTERVIEW: "Working Staff Interview",
  TEMPORARY_STAFF_INTERVIEW: "Temporary Staff Interview",

  //POSITION
  ADMIN: "admin",
  OPERATOR: "operator",
  INSIDE_SALES: "inside sales",

  //ACCESS RIGHTS
  ALL_PERMISSIONS_FOR_THIS_APP: "all permissions for this app",
  AI_MATCHING: "ai matching",
  ABLE_TO_EDIT_ACR_FOR_AI_MATCHING: "able to edit acr for ai matching",
  ABLE_TO_READVIEW_AI_MATCHING: "able to read/view ai matching",
  KANBAN: "kanban",
  ABLE_TO_EDIT_ACR: "able to edit acr",
  CREATE_STAFF_TICKET: "create staff ticket",
  CREATE_CLIENT_TICKET: "create client ticket",
  CREATE_MATCH_TICKET: "create match ticket",
  CREATE_AD_HOC_TICKET: "create ad hoc ticket",
  READ_ALL_STAFF_TICKETS: "read all staff tickets",
  READ_ALL_CLIENT_TICKETS: "read all client tickets",
  READ_ALL_MATCH_TICKETS: "read all match tickets",
  READ_ALL_AD_HOC_TICKETS: "read all ad hoc tickets",
  READ_ONLY_ASSIGNED_STAFF_TICKETS: "read only assigned staff tickets",
  READ_ONLY_ASSIGNED_CLIENT_TICKETS: "read only assigned client tickets",
  READ_ONLY_ASSIGNED_MATCH_TICKETS: "read only assigned match tickets",
  READ_ONLY_ASSIGNED_AD_HOC_TICKETS: "read only assigned ad hoc tickets",
  READ_ONLY_LINKED_TICKETS_WHICH_ARE_ASSIGNED:
    "read only linked tickets which are assigned",
  EDIT_STAFF_TICKETS: "edit staff tickets",
  EDIT_ONLY_ASSIGNED_STAFF_TICKETS: "edit only assigned staff tickets",
  EDIT_CLIENT_TICKETS: "edit client tickets",
  EDIT_ONLY_ASSIGNED_CLIENT_TICKETS: "edit only assigned client tickets",
  EDIT_MATCH_TICKETS: "edit match tickets",
  EDIT_ONLY_ASSIGNED_MATCH_TICKETS: "edit only assigned match tickets",
  EDIT_AD_HOC_TICKETS: "edit ad hoc tickets",
  EDIT_ONLY_ASSIGNED_AD_HOC_TICKETS: "edit only assigned ad hoc tickets",
  DELETE_ARCHIVE_STAFF_TICKETS: "delete (archive) staff tickets",
  DELETE_ARCHIVE_ONLY_ASSIGNED_STAFF_TICKETS:
    "delete (archive) only assigned staff tickets",
  DELETE_ARCHIVE_CLIENT_TICKETS: "delete (archive) client tickets",
  DELETE_ARCHIVE_ONLY_ASSIGNED_CLIENT_TICKETS:
    "delete (archive) only assigned client tickets",
  DELETE_ARCHIVE_MATCH_TICKETS: "delete (archive) match tickets",
  DELETE_ARCHIVE_ONLY_ASSIGNED_MATCH_TICKETS:
    "delete (archive) only assigned match tickets",
  DELETE_ARCHIVE_AD_HOC_TICKETS: "delete (archive) ad hoc tickets",
  DELETE_ARCHIVE_ONLY_ASSIGNED_AD_HOC_TICKETS:
    "delete (archive) only assigned ad hoc tickets",
  SCORE_CARD: "score card",
  CREATE_SCORE_CARDS: "create score cards",
  READ_ALL_SCORE_CARDS: "read all score cards",
  READ_ONLY_ASSIGNED_SCORE_CARDS: "read only assigned score cards",
  EDIT_ALL_SCORE_CARDS: "edit all score cards",
  EDIT_ONLY_ASSIGNED_SCORE_CARDS: "edit only assigned score cards",
  DELETE_ALL_SCORE_CARDS: "delete all score cards",
  DELETE_ONLY_ASSIGNED_SCORE_CARDS: "delete only assigned score cards",
  EOD: "eod",
  ABLE_TO_EDIT_ACR_FOR_EOD: "able to edit acr for eod",
  ABLE_TO_MANAGE_ALL_OF_EOD: "able to manage all of eod",
  ABLE_TO_MANAGE_PAST_DUE_DATE_EOD: "able to manage past due date eod",
  ONLY_ABLE_TO_MANAGE_EODS_WHICH_ARE_ASSIGNED:
    "only able to manage eods which are assigned",
  OPSNAVI_MEMBER_MANAGEMENT: "opsnavi member management",
  APPROVE_OPSNAVI_MEMBER: "approve opsnavi member",
  INVITE_OPSNAVI_MEMBER: "invite opsnavi member",
  DELETE_OPSNAVI_MEMBER: "delete opsnavi member",
  CONVERSION: "conversion",
  ABLE_TO_INPUT_CONVERSION: "able to input conversion",
  ABLE_TO_READ_CONVERSION: "able to read conversion",
  ABLE_TO_EDIT_SUGGESTION_MODE_CONVERSION:
    "able to edit (suggestion mode) conversion",
  ABLE_TO_DELETE_CONVERSION: "able to delete conversion",
  INTERVIEW: "interview",
  ABLE_TO_CREATE_INTERVIEW_FOR_ASSIGNED_PA:
    "able to create interview for assigned pa",
  ABLE_TO_READ_ALL_INTERVIEW_WITHIN_BU: "able to read all interview within bu",
  ABLE_TO_EDIT_SUGGESTION_MODE_INTERVIEWS_FOR_ASSIGNED_PA:
    "able to edit (suggestion mode) interviews for assigned pa",
  ABLE_TO_READ_INTERVIEWS_FOR_ASSIGNED_PA:
    "able to read interviews for assigned pa",
  ABLE_TO_DELETE_ALL_INTERVIEW_WITHIN_BU:
    "able to delete all interview within bu",
  ABLE_TO_DELETE_INTERVIEWS_FOR_ASSIGNED_PA:
    "able to delete interviews for assigned pa",
  TAGS: "tags",
  ABLE_TO_CREATE_TAGS: "able to create tags",
  ABLE_TO_VIEW_TAGS: "able to view tags",
  ABLE_TO_EDIT_TAGS: "able to edit tags",
  ABLE_TO_DELETE_TAGS: "able to delete tags",

  // KANBAN TITLE
  KANBAN_TITLE_CONFIRM_STAFF_NEEDS: "confirm staff needs",
  KANBAN_TITLE_ADJUSTING_INTERVIEW_DATE: "adjusting interview date",
  KANBAN_TITLE_CONFIRMED_INTERVIEW_DATE: "confirmed interview date",
  KANBAN_TITLE_STAFF_AWAITING_RECOMMENDATIONS: "staff awaiting recommendations",
  KANBAN_TITLE_SALES_PREPARATION: "sales preparation",
  KANBAN_TITLE_CREATE_SALES_MATERIAL: "create sales material",
  KANBAN_TITLE_SALES_IN_PROGRESS: "sales in progress",
  KANBAN_TITLE_NEGOTIATE_ORDER_DETAILS: "negotiate order details",
  KANBAN_TITLE_TAKING_ORDERS: "taking orders",
  KANBAN_TITLE_ASSEMBLE_TEAM: "assemble team",
  KANBAN_TITLE_ADJUSTING_WORKPLACE_TOUR: "adjusting workplace tour",
  KANBAN_TITLE_WORKPLACE_TOUR_IN_PROGRESS: "workplace tour in progress",
  KANBAN_TITLE_AWAITING_CLIENT_RESPONSE: "awaiting client response",
  KANBAN_TITLE_CONFIRM_TERMS: "confirm terms",
  KANBAN_TITLE_PROCESSING_LEDGER_STATEMENTS: "processing ledger statements",
  KANBAN_TITLE_CLIENT_CONTRACT_CLOSING: "client contract closing",
  KANBAN_TITLE_FIRST_DAY_OF_DISPATCH_WORK: "first day of dispatch work",
  KANBAN_TITLE_PROCESSING_EMPLOYMENT_INSURANCE:
    "processing employment insurance",
  KANBAN_TITLE_PROCESSING_SOCIAL_INSURANCE: "processing social insurance",
  KANBAN_TITLE_STAFF_EMPLOYED: "staff employed",
  KANBAN_TITLE_TO_DO: "to do",
  KANBAN_TITLE_IN_PROGRESS: "in progress",
  KANBAN_TITLE_DONE: "done",

  // PIPELINE
  PIPELINE_INSIDE_SALES: "inside sales",
  PIPELINE_FIELD_SALES: "field sales",
  PIPELINE_CUSTOMER_SUCCESS: "customer success",
  PIPELINE_AD_HOC_TASKS: "ad hoc tasks",

  // EMPLOYMENT TYPE
  EMPLOYMENT_TYPE_FULL_TIME_INCLUDING_PARTTIME:
    "Full-Time Employee (Including Part-Time)",
  EMPLOYMENT_TYPE_DISPATCH_PARTTIME: "Dispatch (Part-Time)",
  EMPLOYMENT_TYPE_TEMP_TO_PERM_PLACEMENT: "Temp-to-Perm Placement",
  EMPLOYMENT_TYPE_DISPATCH: "Dispatch",
  EMPLOYMENT_TYPE_PLACEMENT_FULL_TIME:
    "Employment Placement/Full-Time Employee",
  EMPLOYMENT_TYPE_PLACEMENT_FIXED_TERM:
    "Employment Placement/Fixed-Term Employee",

  // STAFF STATUS
  STAFF_STATUS_WORKING_STAFF: "working_staff",
  STAFF_STATUS_POOL_STAFF: "pool_staff",
  STAFF_STATUS_TEMPORARY_STAFF: "temporary_staff",

  // EOD STATUS
  NOT_INPUT: "NOT_INPUT",
  TENTATIVELY_CLOSED: "TENTATIVELY_CLOSED",
  CLOSED: "CLOSED",

  // GENDER
  GENDER_MALE: "male",
  GENDER_FEMALE: "female",
  GENDER_MALE_FEMALE: "male and female",

  // JOB LISTING HOLIDAY
  JOB_LISTING_HOLIDAY_WEEKENDS_OFF: "Weekends Off",
  JOB_LISTING_HOLIDAY_FULL_WEEKENDS_OFF: "Full Weekends Off",
  JOB_LISTING_HOLIDAY_WEEKENDS_AND_PUBLIC_HOLIDAYS_OFF:
    "Weekends And Public Holidays Off",
  JOB_LISTING_HOLIDAY_FULL_WEEKENDS_AND_PUBLIC_HOLIDAYS_OFF:
    "Full Weekends And Public Holidays Off",
  JOB_LISTING_HOLIDAY_TWO_DAYS_OFF_PER_WEEK_SHIFT_BASED:
    "Two Days Off Per Week (Shift-Based)",
  JOB_LISTING_HOLIDAY_FULL_TWO_DAYS_OFF_PER_WEEK_SHIFT_BASED:
    "Full Two Days Off Per Week (Shift-Based)",
  JOB_LISTING_HOLIDAY_DAYS_ON_DAYS_OFF: "O Days On O Days Off",
  JOB_LISTING_HOLIDAY_WEEKDAYS_OFF: "Weekdays Off",

  // SMOKING_ENVIRONMENT_OPTIONS
  NO_SMOKING_ON_PERMISES: "no smoking on permises",
  INDOOR_SEPARATE_SMOKE_AREA: "indoor separate smoke area",
  OUTDOOR_SEPARATE_SMOKE_AREA: "outdoor separate smoke area",

  // USABILITY
  USABILITY_REQUIRED: "required",
  USABILITY_NEGOTIABLE: "negotiable",

  // AIR CONDITIONING
  AIR_CONDITIONING_FULL_AIR_CONDITIONING: "full air conditioning",
  AIR_CONDITIONING_SPOT_AIR_CONDITIONING: "spot air conditioning",
  AIR_CONDITIONING_NONE: "none",
  AIR_CONDITIONING_OUTDOORS: "outdoors",

  OTHERS: "Others",

  // EMPLOYMENT_DURATION_VALUE
  DURATION_LONG_TERM: "Long Term",
  DURATION_SHORT_TERM: "Short Term",

  // EMPLOYMENT BRANCH TYPE
  EMPLOYMENT_BRANCH_TYPE_SALES_DEPARTMENT: "Sales Department",
  EMPLOYMENT_BRANCH_TYPE_ADMINISTRATION_DEPARTMENT: "Administration Department",
  EMPLOYMENT_BRANCH_TYPE_CLERICAL: "Clerical",
  EMPLOYMENT_BRANCH_TYPE_COORDINATOR: "Coordinator",
  EMPLOYMENT_BRANCH_TYPE_ATTENDANT: "Attendant",
  EMPLOYMENT_BRANCH_TYPE_IT_DEPARTMENT: "IT Department",
  EMPLOYMENT_BRANCH_TYPE_PUBLIC_RELATIONS_DEPARTMENT:
    "Public Relations Department",
  EMPLOYMENT_BRANCH_TYPE_MARKETING_DEPARTMENT: "Marketing Department",
  EMPLOYMENT_BRANCH_TYPE_CONTROL_DEPARTMENT: "Control Department",
  EMPLOYMENT_BRANCH_TYPE_GENERAL_AFFAIRS_SECTION: "General Affairs Section",
  EMPLOYMENT_BRANCH_TYPE_ADMINISTRATION_SECTION: "Administration Section",
  EMPLOYMENT_BRANCH_TYPE_EDUCATION_SECTION: "Education Section",
  EMPLOYMENT_BRANCH_TYPE_HUMAN_RESOURCES_SECTION: "Human Resources Section",
  EMPLOYMENT_BRANCH_TYPE_SECTION_ONE: "Section One",
  EMPLOYMENT_BRANCH_TYPE_SECTION_TWO: "Section Two",

  OFFICE_PAYMENT_DATE_LAST_DAY_OF_MONTH: "Last Day of Month",

  // DESIRED NATIONALITY
  DESIRED_NATIONALITY_JAPANSESE_ONLY: "japanese only",
  DESIRED_NATIONALITY_FOREIGN_WORKERS_ONLY: "foreign workers only",
  DESIRED_NATIONALITY_JAPANSESE_AND_FOREIGN_WORKERS:
    "japanese and foreign workers",

  // EMPLOYMENT POST
  EMPLOYMENT_POST_GM: "gm",
  EMPLOYMENT_POST_AM: "am",
  EMPLOYMENT_POST_BRANCH_MANAGER: "branch manager",
  EMPLOYMENT_POST_EXECUTIVE_GENERAL_MANAGER: "executive general manager",
  EMPLOYMENT_POST_DEPARTMENT_MANAGER: "department manager",
  EMPLOYMENT_POST_DEPUTY_GENERAL_SECTION_MANAGER:
    "deputy general section manager",
  EMPLOYMENT_POST_DEPUTY_GENERAL_MANAGER: "deputy general manager",
  EMPLOYMENT_POST_GENERAL_SECTION_MANAGER: "general section manager",
  EMPLOYMENT_POST_SECTION_MANAGER: "section manager",
  EMPLOYMENT_POST_ASSISTANT: "assistant",
  EMPLOYMENT_POST_STAFF: "staff",
  EMPLOYMENT_POST_SECTION_CHIEF: "section chief",
  EMPLOYMENT_POST_SUPERVISOR: "supervisor",
};

export const MAP_TRANSLATION: Record<string, string> = {
  [TRANSLATION_KEY.OTHER]: "other",

  // STAFF STATUS
  [TRANSLATION_KEY.TEMPORARY_STAFF]: "temporary_staff",
  [TRANSLATION_KEY.WORKING_STAFF]: "working_staff",
  [TRANSLATION_KEY.POOL_STAFF]: "pool_staff",

  // COMMUTING_METHOD_OPTIONS
  [TRANSLATION_KEY.CAR]: "commuting_method.car",
  [TRANSLATION_KEY.BICYCLE]: "commuting_method.bicycle",
  [TRANSLATION_KEY.MOPED]: "commuting_method.moped",
  [TRANSLATION_KEY.MOTORCYCLE]: "commuting_method.motorcycle",
  [TRANSLATION_KEY.WALKING]: "commuting_method.walking",
  [TRANSLATION_KEY.PUBLIC_TRANSPORTATION]: "commuting_method.public",

  // PREFERRED_WORKING_SCHEDULE_OPTIONS
  [TRANSLATION_KEY.DAY_SHIFT]: "preferred_working_schedule.day_shift",
  [TRANSLATION_KEY.NIGHT_SHIFT]: "preferred_working_schedule.night_shift",
  [TRANSLATION_KEY.ROTATIONAL_SHIFT_INCLUDING_MIDNIGHT]:
    "preferred_working_schedule.rotational_shift.including_midnight",
  [TRANSLATION_KEY.ROTATIONAL_SHIFT_EXCLUDING_MIDNIGHT]:
    "preferred_working_schedule.rotational_shift.excluding_midnight",

  // TIME UNIT
  [TRANSLATION_KEY.HOUR]: "hour",
  [TRANSLATION_KEY.WEEK]: "week",
  [TRANSLATION_KEY.MONTH]: "month",

  // PREFERRED_EMPLOYMENT_DURATION_VALUE
  [TRANSLATION_KEY.LONG_TERM]: "preferred_employment_duration.long_term",
  [TRANSLATION_KEY.SHORT_TERM]: "preferred_employment_duration.short_term",

  //ARCHIVE REASON TITLE OPTIONS
  [TRANSLATION_KEY.CANCELED]: "archive.reason_title.canceled",
  [TRANSLATION_KEY.DUPLICATE]: "archive.reason_title.duplicate",
  [TRANSLATION_KEY.COMPLETED]: "archive.reason_title.completed",
  [TRANSLATION_KEY.MISCOMMUNICATION]: "archive.reason_title.miscommunication",
  [TRANSLATION_KEY.OUTDATED]: "archive.reason_title.outdated",

  //INTERVIEW TYPE OPTIONS
  [TRANSLATION_KEY.POOL_STAFF_INTERVIEW]: "pool_staff_interview",
  [TRANSLATION_KEY.WORKING_STAFF_INTERVIEW]: "working_staff_interview",
  [TRANSLATION_KEY.TEMPORARY_STAFF_INTERVIEW]: "temporary_staff_interview",

  //POSITION
  [TRANSLATION_KEY.ADMIN]: "operations_navi_admin",
  [TRANSLATION_KEY.OPERATOR]: "operator",
  [TRANSLATION_KEY.INSIDE_SALES]: "operator_inside_sales",

  //ACCESS RIGHTS
  [TRANSLATION_KEY.ALL_PERMISSIONS_FOR_THIS_APP]:
    "acr.all_permissions_for_this_app",
  [TRANSLATION_KEY.AI_MATCHING]: "acr.ai_matching",
  [TRANSLATION_KEY.ABLE_TO_EDIT_ACR_FOR_AI_MATCHING]:
    "acr.able_to_edit_acr_for_ai_matching",
  [TRANSLATION_KEY.ABLE_TO_READVIEW_AI_MATCHING]:
    "acr.able_to_readview_ai_matching",
  [TRANSLATION_KEY.KANBAN]: "acr.kanban",
  [TRANSLATION_KEY.ABLE_TO_EDIT_ACR]: "acr.able_to_edit_acr",
  [TRANSLATION_KEY.CREATE_STAFF_TICKET]: "acr.create_staff_ticket",
  [TRANSLATION_KEY.CREATE_CLIENT_TICKET]: "acr.create_client_ticket",
  [TRANSLATION_KEY.CREATE_MATCH_TICKET]: "acr.create_match_ticket",
  [TRANSLATION_KEY.CREATE_AD_HOC_TICKET]: "acr.create_ad_hoc_ticket",
  [TRANSLATION_KEY.READ_ALL_STAFF_TICKETS]: "acr.read_all_staff_tickets",
  [TRANSLATION_KEY.READ_ALL_CLIENT_TICKETS]: "acr.read_all_client_tickets",
  [TRANSLATION_KEY.READ_ALL_MATCH_TICKETS]: "acr.read_all_match_tickets",
  [TRANSLATION_KEY.READ_ALL_AD_HOC_TICKETS]: "acr.read_all_ad_hoc_tickets",
  [TRANSLATION_KEY.READ_ONLY_ASSIGNED_STAFF_TICKETS]:
    "acr.read_only_assigned_staff_tickets",
  [TRANSLATION_KEY.READ_ONLY_ASSIGNED_CLIENT_TICKETS]:
    "acr.read_only_assigned_client_tickets",
  [TRANSLATION_KEY.READ_ONLY_ASSIGNED_MATCH_TICKETS]:
    "acr.read_only_assigned_match_tickets",
  [TRANSLATION_KEY.READ_ONLY_ASSIGNED_AD_HOC_TICKETS]:
    "acr.read_only_assigned_ad_hoc_tickets",
  [TRANSLATION_KEY.READ_ONLY_LINKED_TICKETS_WHICH_ARE_ASSIGNED]:
    "acr.read_only_linked_tickets_which_are_assigned",
  [TRANSLATION_KEY.EDIT_STAFF_TICKETS]: "acr.edit_staff_tickets",
  [TRANSLATION_KEY.EDIT_ONLY_ASSIGNED_STAFF_TICKETS]:
    "acr.edit_only_assigned_staff_tickets",
  [TRANSLATION_KEY.EDIT_CLIENT_TICKETS]: "acr.edit_client_tickets",
  [TRANSLATION_KEY.EDIT_ONLY_ASSIGNED_CLIENT_TICKETS]:
    "acr.edit_only_assigned_client_tickets",
  [TRANSLATION_KEY.EDIT_MATCH_TICKETS]: "acr.edit_match_tickets",
  [TRANSLATION_KEY.EDIT_ONLY_ASSIGNED_MATCH_TICKETS]:
    "acr.edit_only_assigned_match_tickets",
  [TRANSLATION_KEY.EDIT_AD_HOC_TICKETS]: "acr.edit_ad_hoc_tickets",
  [TRANSLATION_KEY.EDIT_ONLY_ASSIGNED_AD_HOC_TICKETS]:
    "acr.edit_only_assigned_ad_hoc_tickets",
  [TRANSLATION_KEY.DELETE_ARCHIVE_STAFF_TICKETS]:
    "acr.delete_archive_staff_tickets",
  [TRANSLATION_KEY.DELETE_ARCHIVE_ONLY_ASSIGNED_STAFF_TICKETS]:
    "acr.delete_archive_only_assigned_staff_tickets",
  [TRANSLATION_KEY.DELETE_ARCHIVE_CLIENT_TICKETS]:
    "acr.delete_archive_client_tickets",
  [TRANSLATION_KEY.DELETE_ARCHIVE_ONLY_ASSIGNED_CLIENT_TICKETS]:
    "acr.delete_archive_only_assigned_client_tickets",
  [TRANSLATION_KEY.DELETE_ARCHIVE_MATCH_TICKETS]:
    "acr.delete_archive_match_tickets",
  [TRANSLATION_KEY.DELETE_ARCHIVE_ONLY_ASSIGNED_MATCH_TICKETS]:
    "acr.delete_archive_only_assigned_match_tickets",
  [TRANSLATION_KEY.DELETE_ARCHIVE_AD_HOC_TICKETS]:
    "acr.delete_archive_ad_hoc_tickets",
  [TRANSLATION_KEY.DELETE_ARCHIVE_ONLY_ASSIGNED_AD_HOC_TICKETS]:
    "acr.delete_archive_only_assigned_ad_hoc_tickets",
  [TRANSLATION_KEY.SCORE_CARD]: "acr.score_card",
  [TRANSLATION_KEY.CREATE_SCORE_CARDS]: "acr.create_score_cards",
  [TRANSLATION_KEY.READ_ALL_SCORE_CARDS]: "acr.read_all_score_cards",
  [TRANSLATION_KEY.READ_ONLY_ASSIGNED_SCORE_CARDS]:
    "acr.read_only_assigned_score_cards",
  [TRANSLATION_KEY.EDIT_ALL_SCORE_CARDS]: "acr.edit_all_score_cards",
  [TRANSLATION_KEY.EDIT_ONLY_ASSIGNED_SCORE_CARDS]:
    "acr.edit_only_assigned_score_cards",
  [TRANSLATION_KEY.DELETE_ALL_SCORE_CARDS]: "acr.delete_all_score_cards",
  [TRANSLATION_KEY.DELETE_ONLY_ASSIGNED_SCORE_CARDS]:
    "acr.delete_only_assigned_score_cards",
  [TRANSLATION_KEY.EOD]: "acr.eod",
  [TRANSLATION_KEY.ABLE_TO_EDIT_ACR_FOR_EOD]: "acr.able_to_edit_acr_for_eod",
  [TRANSLATION_KEY.ABLE_TO_MANAGE_ALL_OF_EOD]: "acr.able_to_manage_all_of_eod",
  [TRANSLATION_KEY.ABLE_TO_MANAGE_PAST_DUE_DATE_EOD]:
    "acr.able_to_manage_past_due_date_eod",
  [TRANSLATION_KEY.ONLY_ABLE_TO_MANAGE_EODS_WHICH_ARE_ASSIGNED]:
    "acr.only_able_to_manage_eods_which_are_assigned",
  [TRANSLATION_KEY.OPSNAVI_MEMBER_MANAGEMENT]: "acr.opsnavi_member_management",
  [TRANSLATION_KEY.APPROVE_OPSNAVI_MEMBER]: "acr.approve_opsnavi_member",
  [TRANSLATION_KEY.INVITE_OPSNAVI_MEMBER]: "acr.invite_opsnavi_member",
  [TRANSLATION_KEY.DELETE_OPSNAVI_MEMBER]: "acr.delete_opsnavi_member",
  [TRANSLATION_KEY.CONVERSION]: "acr.conversion",
  [TRANSLATION_KEY.ABLE_TO_INPUT_CONVERSION]: "acr.able_to_input_conversion",
  [TRANSLATION_KEY.ABLE_TO_READ_CONVERSION]: "acr.able_to_read_conversion",
  [TRANSLATION_KEY.ABLE_TO_EDIT_SUGGESTION_MODE_CONVERSION]:
    "acr.able_to_edit_suggestion_mode_conversion",
  [TRANSLATION_KEY.ABLE_TO_DELETE_CONVERSION]: "acr.able_to_delete_conversion",
  [TRANSLATION_KEY.INTERVIEW]: "acr.interview",
  [TRANSLATION_KEY.ABLE_TO_CREATE_INTERVIEW_FOR_ASSIGNED_PA]:
    "acr.able_to_create_interview_for_assigned_pa",
  [TRANSLATION_KEY.ABLE_TO_READ_ALL_INTERVIEW_WITHIN_BU]:
    "acr.able_to_read_all_interview_within_bu",
  [TRANSLATION_KEY.ABLE_TO_EDIT_SUGGESTION_MODE_INTERVIEWS_FOR_ASSIGNED_PA]:
    "acr.able_to_edit_suggestion_mode_interviews_for_assigned_pa",
  [TRANSLATION_KEY.ABLE_TO_READ_INTERVIEWS_FOR_ASSIGNED_PA]:
    "acr.able_to_read_interviews_for_assigned_pa",
  [TRANSLATION_KEY.ABLE_TO_DELETE_ALL_INTERVIEW_WITHIN_BU]:
    "acr.able_to_delete_all_interview_within_bu",
  [TRANSLATION_KEY.ABLE_TO_DELETE_INTERVIEWS_FOR_ASSIGNED_PA]:
    "acr.able_to_delete_interviews_for_assigned_pa",
  [TRANSLATION_KEY.TAGS]: "acr.tags",

  // KANBAN TITLE
  [TRANSLATION_KEY.ABLE_TO_CREATE_TAGS]: "acr.able_to_create_tags",
  [TRANSLATION_KEY.ABLE_TO_VIEW_TAGS]: "acr.able_to_view_tags",
  [TRANSLATION_KEY.ABLE_TO_EDIT_TAGS]: "acr.able_to_edit_tags",
  [TRANSLATION_KEY.ABLE_TO_DELETE_TAGS]: "acr.able_to_delete_tags",

  [TRANSLATION_KEY.KANBAN_TITLE_CONFIRM_STAFF_NEEDS]:
    "kanban_title_confirm_staff_needs",
  [TRANSLATION_KEY.KANBAN_TITLE_ADJUSTING_INTERVIEW_DATE]:
    "kanban_title_adjusting_interview_date",
  [TRANSLATION_KEY.KANBAN_TITLE_CONFIRMED_INTERVIEW_DATE]:
    "kanban_title_confirmed_interview_date",
  [TRANSLATION_KEY.KANBAN_TITLE_STAFF_AWAITING_RECOMMENDATIONS]:
    "kanban_title_staff_awaiting_recommendations",
  [TRANSLATION_KEY.KANBAN_TITLE_SALES_PREPARATION]:
    "kanban_title_sales_preparation",
  [TRANSLATION_KEY.KANBAN_TITLE_CREATE_SALES_MATERIAL]:
    "kanban_title_create_sales_material",
  [TRANSLATION_KEY.KANBAN_TITLE_SALES_IN_PROGRESS]:
    "kanban_title_sales_in_progress",
  [TRANSLATION_KEY.KANBAN_TITLE_NEGOTIATE_ORDER_DETAILS]:
    "kanban_title_negotiate_order_details",
  [TRANSLATION_KEY.KANBAN_TITLE_TAKING_ORDERS]: "kanban_title_taking_orders",
  [TRANSLATION_KEY.KANBAN_TITLE_ASSEMBLE_TEAM]: "kanban_title_assemble_team",
  [TRANSLATION_KEY.KANBAN_TITLE_ADJUSTING_WORKPLACE_TOUR]:
    "kanban_title_adjusting_workplace_tour",
  [TRANSLATION_KEY.KANBAN_TITLE_WORKPLACE_TOUR_IN_PROGRESS]:
    "kanban_title_workplace_tour_in_progress",
  [TRANSLATION_KEY.KANBAN_TITLE_AWAITING_CLIENT_RESPONSE]:
    "kanban_title_awaiting_client_response",
  [TRANSLATION_KEY.KANBAN_TITLE_CONFIRM_TERMS]: "kanban_title_confirm_terms",
  [TRANSLATION_KEY.KANBAN_TITLE_PROCESSING_LEDGER_STATEMENTS]:
    "kanban_title_processing_ledger_statements",
  [TRANSLATION_KEY.KANBAN_TITLE_CLIENT_CONTRACT_CLOSING]:
    "kanban_title_client_contract_closing",
  [TRANSLATION_KEY.KANBAN_TITLE_FIRST_DAY_OF_DISPATCH_WORK]:
    "kanban_ticket_first_day_of_dispatch_work",
  [TRANSLATION_KEY.KANBAN_TITLE_PROCESSING_EMPLOYMENT_INSURANCE]:
    "kanban_ticket_processing_employment_insurance",
  [TRANSLATION_KEY.KANBAN_TITLE_PROCESSING_SOCIAL_INSURANCE]:
    "kanban_ticket_processing_social_insurance",
  [TRANSLATION_KEY.KANBAN_TITLE_STAFF_EMPLOYED]: "kanban_ticket_staff_employed",
  [TRANSLATION_KEY.KANBAN_TITLE_TO_DO]: "kanban_ticket_to_do",
  [TRANSLATION_KEY.KANBAN_TITLE_IN_PROGRESS]: "kanban_ticket_in_progress",
  [TRANSLATION_KEY.KANBAN_TITLE_DONE]: "kanban_ticket_done",

  // PIPELINE
  [TRANSLATION_KEY.PIPELINE_INSIDE_SALES]: "pipeline_inside_sales",
  [TRANSLATION_KEY.PIPELINE_FIELD_SALES]: "pipeline_field_sales",
  [TRANSLATION_KEY.PIPELINE_CUSTOMER_SUCCESS]: "pipeline_customer_success",
  [TRANSLATION_KEY.PIPELINE_AD_HOC_TASKS]: "pipeline_ad_hoc_tasks",

  // EMPLOYMENT TYPE
  [TRANSLATION_KEY.EMPLOYMENT_TYPE_FULL_TIME_INCLUDING_PARTTIME]:
    "employment_type_full_time_including_parttime",
  [TRANSLATION_KEY.EMPLOYMENT_TYPE_DISPATCH_PARTTIME]:
    "employment_type_dispatch_parttime",
  [TRANSLATION_KEY.EMPLOYMENT_TYPE_TEMP_TO_PERM_PLACEMENT]:
    "employment_type_temp_to_perm_placement",
  [TRANSLATION_KEY.EMPLOYMENT_TYPE_DISPATCH]: "employment_type_dispatch",
  [TRANSLATION_KEY.EMPLOYMENT_TYPE_PLACEMENT_FULL_TIME]:
    "employment_type_placement_full_time",
  [TRANSLATION_KEY.EMPLOYMENT_TYPE_PLACEMENT_FIXED_TERM]:
    "employment_type_placement_fixed_term",

  // EOD STATUS
  [TRANSLATION_KEY.NOT_INPUT]: "not_input",
  [TRANSLATION_KEY.TENTATIVELY_CLOSED]: "tentatively_closed",
  [TRANSLATION_KEY.CLOSED]: "closed",

  // GENDER
  [TRANSLATION_KEY.GENDER_MALE]: "male",
  [TRANSLATION_KEY.GENDER_FEMALE]: "female",
  [TRANSLATION_KEY.GENDER_MALE_FEMALE]: "male_and_female",

  // JOB LISTING HOLIDAY
  [TRANSLATION_KEY.JOB_LISTING_HOLIDAY_WEEKENDS_OFF]:
    "job_listing_holiday_preference.weekends_off",
  [TRANSLATION_KEY.JOB_LISTING_HOLIDAY_FULL_WEEKENDS_OFF]:
    "job_listing_holiday_preference.full_weekends_off",
  [TRANSLATION_KEY.JOB_LISTING_HOLIDAY_WEEKENDS_AND_PUBLIC_HOLIDAYS_OFF]:
    "job_listing_holiday_preference.weekends_and_public_holidays_off",
  [TRANSLATION_KEY.JOB_LISTING_HOLIDAY_FULL_WEEKENDS_AND_PUBLIC_HOLIDAYS_OFF]:
    "job_listing_holiday_preference.full_weekends_and_public_holidays_off",
  [TRANSLATION_KEY.JOB_LISTING_HOLIDAY_TWO_DAYS_OFF_PER_WEEK_SHIFT_BASED]:
    "job_listing_holiday_preference.two_days_off_per_week_shift_based",
  [TRANSLATION_KEY.JOB_LISTING_HOLIDAY_FULL_TWO_DAYS_OFF_PER_WEEK_SHIFT_BASED]:
    "job_listing_holiday_preference.full_two_days_off_per_week_shift_based",
  [TRANSLATION_KEY.JOB_LISTING_HOLIDAY_DAYS_ON_DAYS_OFF]:
    "job_listing_holiday_preference.days_on_days_off",
  [TRANSLATION_KEY.JOB_LISTING_HOLIDAY_WEEKDAYS_OFF]:
    "job_listing_holiday_preference.weekdays_off",

  [TRANSLATION_KEY.OTHERS]: "others",

  // SMOKING_ENVIRONMENT_OPTIONS
  [TRANSLATION_KEY.NO_SMOKING_ON_PERMISES]: "no_smoking_on_permises",
  [TRANSLATION_KEY.INDOOR_SEPARATE_SMOKE_AREA]: "indoor_separate_smoke_area",
  [TRANSLATION_KEY.OUTDOOR_SEPARATE_SMOKE_AREA]: "outdoor_separate_smoke_area",

  // USABILITY
  [TRANSLATION_KEY.USABILITY_REQUIRED]: "required",
  [TRANSLATION_KEY.USABILITY_NEGOTIABLE]: "negotiable",

  // AIR CONDITIONING
  [TRANSLATION_KEY.AIR_CONDITIONING_FULL_AIR_CONDITIONING]:
    "full_air_conditioning",
  [TRANSLATION_KEY.AIR_CONDITIONING_SPOT_AIR_CONDITIONING]:
    "spot_air_conditioning",
  [TRANSLATION_KEY.AIR_CONDITIONING_NONE]: "none",
  [TRANSLATION_KEY.AIR_CONDITIONING_OUTDOORS]: "outdoors",

  // PREFERRED_EMPLOYMENT_DURATION_VALUE
  [TRANSLATION_KEY.DURATION_LONG_TERM]:
    "preferred_employment_duration.long_term",
  [TRANSLATION_KEY.DURATION_SHORT_TERM]:
    "preferred_employment_duration.short_term",

  // STAFF STATUS
  [TRANSLATION_KEY.STAFF_STATUS_WORKING_STAFF]: "working_staff",
  [TRANSLATION_KEY.STAFF_STATUS_POOL_STAFF]: "pool_staff",
  [TRANSLATION_KEY.STAFF_STATUS_TEMPORARY_STAFF]: "temporary_staff",

  // EMPLOYMENT BRANCH TYPE
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_SALES_DEPARTMENT]:
    "employment_branch_type.sales_department",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_ADMINISTRATION_DEPARTMENT]:
    "employment_branch_type.administration_department",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_CLERICAL]:
    "employment_branch_type.clerical",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_COORDINATOR]:
    "employment_branch_type.coordinator",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_ATTENDANT]:
    "employment_branch_type.attendant",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_IT_DEPARTMENT]:
    "employment_branch_type.it_department",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_PUBLIC_RELATIONS_DEPARTMENT]:
    "employment_branch_type.public_relations_department",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_MARKETING_DEPARTMENT]:
    "employment_branch_type.marketing_department",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_CONTROL_DEPARTMENT]:
    "employment_branch_type.control_department",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_GENERAL_AFFAIRS_SECTION]:
    "employment_branch_type.general_affairs_section",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_ADMINISTRATION_SECTION]:
    "employment_branch_type.administration_section",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_EDUCATION_SECTION]:
    "employment_branch_type.education_section",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_HUMAN_RESOURCES_SECTION]:
    "employment_branch_type.human_resources_section",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_SECTION_ONE]:
    "employment_branch_type.section_one",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_SECTION_TWO]:
    "employment_branch_type.section_two",

  [TRANSLATION_KEY.OFFICE_PAYMENT_DATE_LAST_DAY_OF_MONTH]: "last_day_of_month",

  // DESIRED NATIONALITY
  [TRANSLATION_KEY.DESIRED_NATIONALITY_JAPANSESE_ONLY]: "japanese_only",
  [TRANSLATION_KEY.DESIRED_NATIONALITY_FOREIGN_WORKERS_ONLY]:
    "foreign_workers_only",
  [TRANSLATION_KEY.DESIRED_NATIONALITY_JAPANSESE_AND_FOREIGN_WORKERS]:
    "japanese_and_foreign_workers",

  // EMPLOYMENT POST
  [TRANSLATION_KEY.EMPLOYMENT_POST_GM]: "employment_post.gm",
  [TRANSLATION_KEY.EMPLOYMENT_POST_AM]: "employment_post.am",
  [TRANSLATION_KEY.EMPLOYMENT_POST_BRANCH_MANAGER]:
    "employment_post.branch_manager",
  [TRANSLATION_KEY.EMPLOYMENT_POST_EXECUTIVE_GENERAL_MANAGER]:
    "employment_post.executive_general_manager",
  [TRANSLATION_KEY.EMPLOYMENT_POST_DEPARTMENT_MANAGER]:
    "employment_post.department_manager",
  [TRANSLATION_KEY.EMPLOYMENT_POST_DEPUTY_GENERAL_SECTION_MANAGER]:
    "employment_post.deputy_general_section_manager",
  [TRANSLATION_KEY.EMPLOYMENT_POST_DEPUTY_GENERAL_MANAGER]:
    "employment_post.deputy_general_manager",
  [TRANSLATION_KEY.EMPLOYMENT_POST_GENERAL_SECTION_MANAGER]:
    "employment_post.general_section_manager",
  [TRANSLATION_KEY.EMPLOYMENT_POST_SECTION_MANAGER]:
    "employment_post.section_manager",
  [TRANSLATION_KEY.EMPLOYMENT_POST_ASSISTANT]: "employment_post.assistant",
  [TRANSLATION_KEY.EMPLOYMENT_POST_STAFF]: "employment_post.staff",
  [TRANSLATION_KEY.EMPLOYMENT_POST_SECTION_CHIEF]:
    "employment_post.section_chief",
  [TRANSLATION_KEY.EMPLOYMENT_POST_SUPERVISOR]: "employment_post.supervisor",
};
